export const setPageTitle = (configTitle: string, title: string) => {
  if (document) {
    document.title = configTitle.replace(':promoTitle:', title)
  }
}
